import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { toolkitCx } from "../../../constants";
import Heading from "../../atoms/Heading";
import Text from "../../atoms/Text";
/**
 * A simple card component.
 *
 * @component
 *
 * @param {ICardProps} props The component props.
 * @param {string} [props.className] The CSS class to apply to the component.
 * @param {"default" | "card"} [props.bg="card"] The background color of the card.
 * @param {string} [props.text] The text content of the card.
 * @param {React.ReactNode} [props.title] The title of the card.
 * @param {boolean} [props.slim=false] Whether the card should be slim or not.
 * @returns {JSX.Element} The rendered `Card` component.
 */
const Card = ({ bg = "card", className, children, title, text, slim = false, }) => (_jsxs("div", { className: cx({
        "rounded-lg": true,
    }, toolkitCx.layout.background[bg], toolkitCx.layout.border.default, toolkitCx.layout.border.weight.default, toolkitCx.layout.text.default, { [toolkitCx.layout.spacing.both.md]: !slim }, { [toolkitCx.layout.spacing.both.sm]: slim }, className), children: [title && (_jsx(Heading, { tag: "h4", size: "2xl", className: "mb-4 block w-full", children: title })), _jsx("div", { className: "clear-both", children: text ? _jsx(Text, { tag: "p", children: text }) : children })] }));
export default Card;
//# sourceMappingURL=Card.js.map